module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Cartner Convos',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
    buttonUpdate: 'Update',
  },
  table: {
    title: {
      index: 'NO.',
      show: 'Active',
      title: 'Question',
      createDate: 'Create Date',
      scheduleDate: 'Sch. Date',
      action: 'Action',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      schedule: 'Schedule',
      summary: 'Summary',
      inactive: 'InActive',
      active: 'Active',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this card?',
      edit: 'Are you sure to edit this card?',
      enable: 'Are you sure you want to enable this Cartner Convo?',
      disable: 'Are you sure you want to disable this Cartner Convo?',
      confirmPassword: 'Please input your password to confirm.',
      confirmSchedule: 'Are you sure to schedule this question?',
    },
  },
  form: {
    image1x1: 'Please upload a 1x1 image',
    imageUpload: 'Upload BG Image (optional)',
    title: 'Question',
    result: 'Result',
    answerA: 'Answer A',
    subCopyA: 'Subcopy A',
    answerB: 'Answer B',
    subCopyB: 'Subcopy B',
    answerC: 'Answer C',
    subCopyC: 'Subcopy C',
    answerD: 'Answer D',
    subCopyD: 'Subcopy D',
    btnUpdateCartnerConvos: 'UPDATE',
    btnCreateCartnerConvos: 'ADD',
    updateConvos: 'Edit Convos',
    createConvos: 'Add Convos',
    scheduleTile: 'Schedule This Convo',
    SummaryTile: 'Convo Summary',
    defaultImage: 'Default image',
    btnSubmit: 'Submit',
    textColor: 'Text Color',
    time: {
      startTimePlaceholder: 'Start time',
      endTimePlaceholder: 'End time',
      startDatePlaceholder: 'Start date',
      endDatePlaceholder: 'End date',
    },
  },
  validate: {
    titleBlank: 'Question is required to fill',
    answerBlank: 'Answer Needed',
    startBeforeNow: 'The start date time must be after now.',
    endBeforeNow: 'The end date time must be after now.',
    startBeforeEnd: 'The start date must be before the end date time.',
    startTimeBlank: 'Please input start time.',
    endTimeBlank: 'Please input end time.',
    startDateBlank: 'Please input start date.',
    endDateBlank: 'Please input end date.',
    textColorBlank: 'Please choose text color.',
  },
  message: {
    error: {
      updateQuestion: 'Failed to update question. Please try again.',
      createQuestion: 'Failed to create question. Please try again.',
      summaryQuestion: 'Can not view the question summary. Please try again.',
      uploadImage: 'There was an error while uploading the image. Please try again.',
      requireUpload: 'Please upload an image.',
      updateProductEcomError: 'Failed to update ECOM product.',
      isAnswered: 'A question cannot be edited once answered.',
      duplicateAnswer: 'Answers can not be the same.',
      endDate: 'Activating the question is not permitted once the end date has passed.',
    },
    success: {
      updateQuestion: 'Question successfully updated.',
      createQuestion: 'Question successfully created.',
      deleteQuestion: 'Question successfully deleted.',
      updateProductEcomSuccess: 'ECOM Product successfully updated.',
      scheduleTile: 'The question successfully scheduled.',
    },
  },
};
